import { toast } from 'react-toastify';
import axios from 'axios';
import {
  DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_BEGIN,
  DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_SUCCESS,
  DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_FAILURE,
  DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function loadGithubUserData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_BEGIN,
    });

    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId, true);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}code-export/github/load-data`,
        header,
      );
      doRequest.then(
        (res) => {
          const { data } = res;
          const { success, message, userData, repoData } = data;
          if (success) {
            dispatch({
              type: DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_SUCCESS,
              data: data,
            });
            resolve(data);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_FAILURE,
              data: { error: message },
            });
            reject(message);
          }
        },
        (err) => {
          const { response } = err;
          if (response && response.data) {
            const { message } = response.data;
            console.log('message :>> ', message);
            dispatch({
              type: DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_FAILURE,
              data: { error: message },
            });
            reject(message);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_FAILURE,
              data: { error: err.message },
            });
            reject(err);
          }
        },
      );
    });

    return promise;
  };
}

export function dismissLoadGithubUserDataError() {
  return {
    type: DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_BEGIN:
      return {
        ...state,
        loadGithubUserDataPending: true,
        loadGithubUserDataError: null,
      };

    case DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_SUCCESS:
      return {
        ...state,
        loadGithubUserDataPending: false,
        loadGithubUserDataError: null,
        githubUserData: action.data.userData,
        githubRepoData: action.data.repoData,
      };

    case DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_FAILURE:
      return {
        ...state,
        loadGithubUserDataPending: false,
        loadGithubUserDataError: action.data.error,
        githubUserData: null,
        githubRepoData: [],
      };

    case DEPLOYMENT_SETTING_LOAD_GITHUB_USER_DATA_DISMISS_ERROR:
      return {
        ...state,
        loadGithubUserDataError: null,
      };

    default:
      return state;
  }
}
